module.exports = __webpack_public_path__ + "img/about-home-banner-2-test.292585d3.jpg";